"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    mens: function() {
        return mens;
    },
    tnt: function() {
        return tnt;
    },
    womens: function() {
        return womens;
    }
});
const mens = [
    {
        id: "a-mens-01",
        wrestlerIds: [
            "mjf"
        ],
        championshipId: "a-mens",
        startDate: new Date("Nov 19, 2022")
    },
    {
        id: "a-mens-02",
        wrestlerIds: [
            "jonmoxley"
        ],
        championshipId: "a-mens",
        startDate: new Date("Sep 21, 2022"),
        endDate: new Date("Nov 19, 2022")
    },
    {
        id: "a-mens-03",
        wrestlerIds: [
            "cm-punk"
        ],
        championshipId: "a-mens",
        startDate: new Date("Sep 4, 2022"),
        endDate: new Date("Sep 7, 2022")
    },
    {
        id: "a-mens-04",
        wrestlerIds: [
            "jonmoxley"
        ],
        championshipId: "a-mens",
        startDate: new Date("Jun 26, 2022"),
        endDate: new Date("Sep 4, 2022")
    },
    {
        id: "a-mens-05",
        wrestlerIds: [
            "cm-punk"
        ],
        championshipId: "a-mens",
        startDate: new Date("May 29, 2022"),
        endDate: new Date("Aug 24, 2022")
    },
    {
        id: "a-mens-06",
        wrestlerIds: [
            "hangman"
        ],
        championshipId: "a-mens",
        endDate: new Date("May 29, 2022"),
        startDate: new Date("Nov 13, 2021")
    },
    {
        id: "a-mens-07",
        wrestlerIds: [
            "kennyomega"
        ],
        championshipId: "a-mens",
        startDate: new Date("Dec 2, 2020"),
        endDate: new Date("Nov 13, 2021")
    },
    {
        id: "a-mens-08",
        wrestlerIds: [
            "jonmoxley"
        ],
        championshipId: "a-mens",
        startDate: new Date("Feb 29, 2020"),
        endDate: new Date("Dec 2, 2020")
    },
    {
        id: "a-mens-09",
        wrestlerIds: [
            "chrisjericho"
        ],
        championshipId: "a-mens",
        startDate: new Date("Aug 31, 2019"),
        endDate: new Date("Feb 29, 2020")
    }
];
const womens = [];
const tnt = [
    {
        id: "a-tnt-0",
        wrestlerIds: [
            "christian-cage"
        ],
        championshipId: "a-tnt",
        startDate: new Date("Sep 23, 2023")
    },
    {
        id: "a-tnt-1",
        wrestlerIds: [
            "luchasaurus"
        ],
        championshipId: "a-tnt",
        startDate: new Date("Jun 17, 2023"),
        endDate: new Date("Sep 23, 2023")
    },
    {
        id: "a-tnt-2",
        wrestlerIds: [
            "wardlow"
        ],
        championshipId: "a-tnt",
        startDate: new Date("Apr 19, 2023"),
        endDate: new Date("Jun 17, 2023")
    },
    {
        id: "a-tnt-3",
        wrestlerIds: [
            "powerhouse-hobbs"
        ],
        championshipId: "a-tnt",
        startDate: new Date("Mar 8, 2023"),
        endDate: new Date("Apr 19, 2023")
    },
    {
        id: "a-tnt-4",
        wrestlerIds: [
            "wardlow"
        ],
        championshipId: "a-tnt",
        startDate: new Date("Mar 5, 2023"),
        endDate: new Date("Mar 8, 2023")
    },
    {
        id: "a-tnt-5",
        wrestlerIds: [
            "samoa-joe"
        ],
        championshipId: "a-tnt",
        startDate: new Date("Feb 1, 2023"),
        endDate: new Date("Mar 5, 2023")
    },
    {
        id: "a-tnt-6",
        wrestlerIds: [
            "darby-allin"
        ],
        championshipId: "a-tnt",
        startDate: new Date("Jan 4, 2023"),
        endDate: new Date("Feb 1, 2023")
    },
    {
        id: "a-tnt-7",
        wrestlerIds: [
            "samoa-joe"
        ],
        championshipId: "a-tnt",
        startDate: new Date("Nov 19, 2022"),
        endDate: new Date("Jan 4, 2023")
    },
    {
        id: "a-tnt-8",
        wrestlerIds: [
            "wardlow"
        ],
        championshipId: "a-tnt",
        startDate: new Date("Jul 6, 2022"),
        endDate: new Date("Nov 19, 2022")
    },
    {
        id: "a-tnt-9",
        wrestlerIds: [
            "scorpiosky"
        ],
        championshipId: "a-tnt",
        startDate: new Date("Apr 27, 2022"),
        endDate: new Date("Jul 6, 2022")
    },
    {
        id: "a-tnt-10",
        wrestlerIds: [
            "sammyguevara"
        ],
        championshipId: "a-tnt",
        startDate: new Date("Apr 15, 2022"),
        endDate: new Date("Apr 27, 2022")
    },
    {
        id: "a-tnt-11",
        wrestlerIds: [
            "scorpiosky"
        ],
        championshipId: "a-tnt",
        startDate: new Date("Mar 9, 2022"),
        endDate: new Date("Apr 15, 2022")
    },
    {
        id: "a-tnt-12",
        wrestlerIds: [
            "sammyguevara"
        ],
        championshipId: "a-tnt",
        startDate: new Date("Jan 26, 2022"),
        endDate: new Date("Mar 9, 2022")
    },
    {
        id: "a-tnt-13",
        wrestlerIds: [
            "miro"
        ],
        championshipId: "a-tnt",
        startDate: new Date("May 12, 2021"),
        endDate: new Date("Sep 29, 2021")
    }
];
